import {AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FileService} from "../../providers/file.service";
import {VetineoFile} from "../../models/file/vetineo-file.model";
import {Subscription} from "rxjs";
import {Photo, VetDoctorData} from "../../models/vet-clinic-info-data.model";
import {VImage, VImageUpload} from "../../models/vet-clinic.model";
import {CommonUtils} from "../../utils/common";
import {VetClinicStartContextData} from "../../models/vet-clinic-start-context-data.model";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {take} from "rxjs/operators";
import {ModalController} from "@ionic/angular";
import {VImageManagerComponent} from "../v-image-manager/v-image-manager.component";

@Component({
  selector: 'app-v-image-editor',
  templateUrl: './v-image-editor.component.html',
  styleUrls: ['./v-image-editor.component.scss'],
})
export class VImageEditorComponent implements AfterViewInit, OnDestroy {

  @Output() vFileChanged = new EventEmitter<VetineoFile[]>();
  @Output() imageFileChanged = new EventEmitter<number>();

  @Input() vImages: VImage[];

  @Input() urlPathPrefix: string;

  @Input() multiple: boolean = false;
  @Input() type: string;
  @Input() vetcodeId: number;

  private vImagesLibrary: VImage[] =[];
  files: File[];

  hasUnsavedChanges: boolean = false;

  accept: string = 'image/jpeg,image/jpg,image/png';
  uploadNewImage: boolean = false;

  constructor(
    private fileService: FileService,
    public commonUtils : CommonUtils,
    private vetClinicService: VetClinicService,
    private modalController: ModalController
  ) {
  }

  onSelect(event) {
    if (event && event.addedFiles) {
      if (!this.files) this.files = [];
      this.files.push(event.addedFiles);

      event.addedFiles.forEach(file => {
        throw this.fileService.uploadFile(file).pipe(take(1)).subscribe(uploadedVImage => {
          this.vImagesLibrary.unshift(uploadedVImage);
          this.fileService.setVImages(this.vImagesLibrary);
        })
      })
    }

    /*
      this.files.forEach(file => {
        this.readFile(file).then(fileContents => {
          this.vImages.push(new VImageUpload(file.name, file.type, fileContents))
        }).then(() => {
          this.imageFileChanged.emit(this.vImages);
          });
      })
  */
  }

  onRemove(event) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  ngAfterViewInit() {
  }

  onUploadFiles() {
    /*    if (this.type === 'vetDoctor') {

          this.imageFileChanged.emit(new VImage());
        } else {
          this.files.forEach(file => {
            this.subscriptions.push(this.fileService.uploadFile(file).subscribe(e => {
              console.log(e);
              this.vFiles.push(e);
            }));
          });
          this.vFileChanged.emit(this.vFiles);
        }*/
  }

  ngOnDestroy(): void {
  }

  enableImageUpload() {
    if (!this.uploadNewImage) this.uploadNewImage = true;
  }

  cancelImageUpload() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany. Na pewno chcesz zrezygnować z zapisu?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.uploadNewImage = false;
        this.files = [];
        this.hasUnsavedChanges = false;
      }, () => {
      });
    } else {
      this.uploadNewImage = false;
      this.hasUnsavedChanges = false;
    }
  }

  async openImageLibrary() {
    const modal = await this.modalController.create({
      component: VImageManagerComponent,
      componentProps: {
        'vetcodeId': this.vetcodeId
      }
    });
    return await modal.present();
  }
}
